import React from 'react'
import { Link } from "react-router-dom";
export default function AdBanner() {
  return (
    <>
      <section className="adBanner">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="subAdBan">
                    <Link to="/TravelPackages/Bali"><img src="assets/img/ad-banner1.jpg" alt="" /></Link>
                </div>
            </div>
        </div>
    </div>
</section>

    </>
  )
}
